import { DocumentNode } from 'graphql';

/**
 * True when the GraphQL operation is a mutation, for both forms accepted
 * by requestGraph(): raw string sources and parsed DocumentNodes.
 */
const isMutationOperation = (query: string | DocumentNode): boolean =>
  typeof query === 'string'
    ? /^\s*mutation\b/.test(query)
    : query.definitions.some(
        definition =>
          definition.kind === 'OperationDefinition' &&
          definition.operation === 'mutation'
      );

export default isMutationOperation;
